import { supabase } from '../lib/supabase';
import { RegistrationFormData } from '../types';

async function getUserMetadata(userId: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('Usuário não autenticado');
  }

  const metadata = user.user_metadata;

  if (!metadata?.name || !metadata?.whatsapp) {
    throw new Error('Dados do usuário incompletos. Por favor, atualize seu perfil.');
  }
  
  const whatsapp = metadata.whatsapp.replace(/^\+55/, ''); // Remove +55 prefix if present

  return {
    name: metadata.name,
    whatsapp: whatsapp
  };
}

export async function createRegistration(data: RegistrationFormData) {
  console.log('Starting registration process:', data);

  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    console.log('Auth user check:', {
      hasUser: !!user,
      error: userError
    });

    if (!user) {
      throw new Error('Usuário não autenticado');
    }

    // Get user metadata using RPC function
    const metadata = await getUserMetadata(user.id);

    console.log('User metadata:', metadata);

    if (!metadata.name || !metadata.whatsapp) {
      throw new Error('Dados do usuário incompletos. Por favor, atualize seu perfil.');
    }

    console.log('Creating registration record');
    const { data: registration, error: registrationError } = await supabase
      .from('registrations')
      .insert({
        user_id: user.id,
        name: metadata.name,
        whatsapp: `+55${metadata.whatsapp.replace(/^\+55/, '')}`, // Ensure consistent +55 prefix
        origin_city: data.originCity,
        max_price: data.maxPrice,
      })
      .select()
      .single();

    console.log('Registration result:', {
      success: !!registration,
      error: registrationError
    });

    if (registrationError) {
      throw new Error('Erro ao criar registro: ' + registrationError.message);
    }

    if (!registration) {
      throw new Error('Erro ao criar registro');
    }

    const destinationCitiesData = data.destinationCities.map(city => ({
      registration_id: registration.id,
      city_name: city,
    }));

    console.log('Adding destination cities:', destinationCitiesData);
    const { error: destinationError } = await supabase
      .from('destination_cities')
      .insert(destinationCitiesData);

    console.log('Destination cities result:', {
      error: destinationError
    });

    if (destinationError) {
      throw new Error('Erro ao adicionar cidades de destino: ' + destinationError.message);
    }

    console.log('Registration completed successfully');
    return registration;
  } catch (err) {
    console.error('Registration error:', {
      error: err,
      message: err instanceof Error ? err.message : 'Unknown error',
      stack: err instanceof Error ? err.stack : undefined
    });
    throw new Error(err instanceof Error ? err.message : 'Erro ao realizar cadastro');
  }
}